import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import styled from '@emotion/styled';

interface IScrollToBtn {
    title: string;
    disabled?: boolean;
}

const ScrollToButtonWrapper = styled.div`
    margin-top: 7px;
    min-width: 100%;
    display: inline-block;
    position: relative;
`;

const ScrollToButton = styled.button<{
    disabled: boolean;
}>`
    color: ${({ disabled, theme }) =>
        disabled ? theme.button.primary.textDisabled : theme.button.primary.text};
    font-size: 1.333rem;
    line-height: 1.428571429;
    text-align: center;
    font-weight: 600;
    white-space: nowrap;
    min-width: 100%;
    height: 30px;
    border: none;
    padding: 4px 52px 4px 20px;
    background-color: ${({ disabled, theme }) =>
        disabled ? theme.button.primary.backgroundDisabled : theme.button.primary.background};
    touch-action: manipulation;
    vertical-align: middle;

    &:hover {
        background-color: ${({ theme }) => theme.button.primary.backgroundHover};
    }
`;

const ScrollToButtonIcon = styled.span`
    background-color: ${({ theme }) => theme.colors.white[50]};
    bottom: 0;
    color: ${({ theme }) => theme.button.primary.text};
    fill: ${({ theme }) => theme.button.primary.icon};
    font-size: 12px;
    line-height: 35px !important;
    position: absolute;
    right: 0;
    top: 0;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ScrollToBtn = (props: IScrollToBtn) => {
    const { title } = props;
    const disabled = props.disabled || false;

    const handleScroll = () => {
        let anchor = document.querySelector('.requestFormContainer');
        if (anchor) {
            anchor.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };

    return (
        <ScrollToButtonWrapper>
            {/* <OnBoardCreditLabel
                title={__('request.ObcTitle', 'dreamlines')}
                text={__('request.ObcText', 'dreamlines')}
            /> */}
            <ScrollToButton onClick={handleScroll} disabled={disabled}>
                {title}
                <ScrollToButtonIcon>
                    <ArrowDownIcon width="15" height="11" />
                </ScrollToButtonIcon>
            </ScrollToButton>
        </ScrollToButtonWrapper>
    );
};

export default ScrollToBtn;
